export default __webpack_public_path__ + "static/media/landing_slide.c4e8edf5.png";